import GradientTop from '../../../../shared/assets/images/png/gradientTop.png';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const PilotGradientTop = styled.img<React.CSSProperties>`
  opacity: ${(props) => props.opacity || 1};
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

PilotGradientTop.defaultProps = {
  src: GradientTop,
};

export default withImage(PilotGradientTop, false);
